import React, {useState} from "react";
import {AccountingPeriod, AccountingPeriodList, AccountingPeriodRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {Chip, TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {dateToString} from "../../../../components/utils/dates";

const statusColor: Record<string, "default" | "success" | "warning" | "error"> = {
    ABIERTO: "success",
    CERRADO: "warning",
    BLOQUEADO: "error",
};

export const AccountingPeriodListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<AccountingPeriodList> = {
        title: "Períodos contables",
        onClick: "/app/admin/accounting/period",
        headers: [
            {title: "Año"},
            {title: "Nombre"},
            {title: "Estado"},
            {title: "Inicio"},
            {title: "Fin"},
        ],
        decorator: (bean: AccountingPeriodList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
                    {bean.yearValue}
                </TableCell>
                <TableCell>{bean.name}</TableCell>
                <TableCell>
                    <Chip
                        label={bean.status}
                        color={statusColor[bean.status] ?? "default"}
                        size="small"
                    />
                </TableCell>
                <TableCell>{dateToString(bean.startDate)}</TableCell>
                <TableCell>{dateToString(bean.endDate)}</TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(AccountingPeriodRestControllerApiFactory);
            return ctrl.pageAccountingPeriod(currentPage, size, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
